import { render } from "./FolderPicker.vue?vue&type=template&id=ca07d2ba&ts=true"
import script from "./FolderPicker.vue?vue&type=script&lang=ts"
export * from "./FolderPicker.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__